import VisualizarUsuarioModal from './VisualizarUsuarioModal';

export default VisualizarUsuarioModal;
